import React, { useEffect } from "react";
import useApi from "../../../hooks/useApi";
import externalApiService from "../../../services/externalApiService";
import { toast, ToastContainer } from "react-toastify";
import { browserHistory } from "react-router";

export default function AccountingSoftwareTokenEndPoint() {
  const getMyobTokenApi = useApi(externalApiService.GetMyobAccessToken);
  const getXeroTokenApi = useApi(externalApiService.GetXeroAccessToken);
  const getQuickbookTokenApi = useApi(externalApiService.GetQuickbookAccessToken);

  const safeRedirect = (url) => {
    if (!url) {
      // default fallback
      window.location.href = "/client/accounting-software";
      return;
    }
    try {
      if (browserHistory && typeof browserHistory.push === "function") {
        browserHistory.push(url);
      } else {
        window.location.href = url;
      }
    } catch (e) {
      window.location.href = url;
    }
  };

  const handleResponseAndRedirect = (response, returnUrl, providerName) => {
    if (!response) {
      toast.error(`Failed to complete authentication with ${providerName}. Please contact your administrator.`);
      return;
    }

    const ok = response.data && (response.data.success === true || response.status === 200);
    if (!ok) {
      const msg =
        (response.data && response.data.message) ||
        (response.data && response.data.error) ||
        `Failed to complete authenticate with ${providerName}.`;
      toast.error(msg);
      return;
    }

    safeRedirect(returnUrl || "/client/accounting-software");
  };

  const getXeroAccessToken = async (code, state, returnUrl) => {
    try {
      const response = await getXeroTokenApi.request({
        code,
        state,
      });
      handleResponseAndRedirect(response, returnUrl, "Xero");
    } catch (err) {
      console.error("Xero auth error:", err);
      toast.error("Failed to complete authenticate with Xero. Please contact your administrator.");
    }
  };

  const getMyobAccessToken = async (code, entityId, returnUrl) => {
    try {
      const response = await getMyobTokenApi.request({
        code,
        entityId,
      });
      handleResponseAndRedirect(response, returnUrl, "MYOB");
    } catch (err) {
      console.error("MYOB auth error:", err);
      toast.error("Failed to complete authenticate with MYOB. Please contact your administrator.");
    }
  };

  const getQuickbookAccessToken = async (code, state, realmId, returnUrl) => {
    try {
      const response = await getQuickbookTokenApi.request({
        code,
        state,
        realmId,
      });
      handleResponseAndRedirect(response, returnUrl, "QuickBooks");
    } catch (err) {
      console.error("QuickBooks auth error:", err);
      toast.error("Failed to complete authenticate with QuickBooks. Please contact your administrator.");
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("Auth redirect params:", urlParams.toString());

    const authCode = urlParams.get("authCode") || urlParams.get("code") || null;
    const xeroState = urlParams.get("xeroState") || urlParams.get("state") || null;
    const provider = urlParams.get("provider") || null;
    const entityId = urlParams.get("entityId") || null;
    const returnUrl = urlParams.get("returnUrl") || "/";
    const realmId = urlParams.get("realmId") || null;

    if (!provider) {
      toast.error("Failed to complete authentication: provider missing.");
      safeRedirect("/client/accounting-software");
      return;
    }

    if (provider === "Xero") {
      if (!authCode) {
        toast.error("Missing authorization code for Xero.");
        safeRedirect("/client/accounting-software");
        return;
      }
      getXeroAccessToken(authCode, xeroState, returnUrl);
    } else if (provider === "Myob") {
      if (!authCode || !entityId) {
        toast.error("Missing parameters for MYOB authentication.");
        safeRedirect("/client/accounting-software");
        return;
      }
      getMyobAccessToken(authCode, entityId, returnUrl);
    } else if (provider === "Quickbook") {
      if (!authCode) {
        toast.error("Missing authorization code for QuickBooks.");
        safeRedirect("/client/accounting-software");
        return;
      }
      getQuickbookAccessToken(authCode, xeroState, realmId, returnUrl);
    } else {
      toast.error("Unknown provider. Please contact your administrator.");
      safeRedirect("/client/accounting-software");
    }
  }, []);

  return (
    <>
      <ToastContainer />
      <div class="card">
         <div class="card-body">
      <div class="row">
        <div class="col-8 col-lg-12 m-auto text-center">
          <h5 class="font-weight-bold mt-2">Sync Your Accounting Software</h5>
 
 <div className="text"> Verifying token details... Please wait...</div>
 </div>
 </div>
 </div>
 </div>
     
    </>
  );
}
